import HeadTittle from '../../../../../components/HeadTittle';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { EditIcon } from '../../../../../components/buttons/IconButtons';
import DividerWithText from './../../../../../components/DividerWithText';
import DetailsStep from './DetailsStep';
import DefineAreaStep from './DefineAreaStep';
import GeofencesUpdateApp from './../Functionality/GeofencesUpdateApp';
import DivContainerBody from '../../../../../components/DivContainerBody';
import ActiveScheduleStep from './ActiveSheduleStep';
import {permissionObj} from "../../../../../Helpers/permission";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const GeofencesUpdate = () => {
    const {
        DEV,
        permission,
        t,
        disabled,
        item,
        emptyFields,
        setItem,
        setDayArray,
        dayArray,
        handleChange,
        geofences,
        setGeofences,
        latitude,
        setLatitude,
        longitude,
        setLongitude,
        center,
        handleUpdate,
        handleOnBack,
        isCloseTimeInvalid
    } = GeofencesUpdateApp();

    return (
        <>
            <HeadTittle name={disabled ? 'details' : 'update'} onBack={handleOnBack}>
                {(DEV || permission?.includes(permissionObj?.WEB_TRAFFIC_MANAGE_GEOFENCES_UPDATE)) &&
                    <ButtonAction
                        id='btn_gu_update'
                        name={'update'}
                        className={'btn-icon-edit'}
                        Icon={EditIcon}
                        onClick={() => {
                            handleUpdate();
                        }}
                    />
                }
            </HeadTittle>
            <DivContainerBody>
                <div className='col-12 mb-4'>
                    <DividerWithText title={t('details')} />
                </div>

                <DetailsStep
                    disabled={disabled}
                    handleChange={handleChange}
                    emptyFields={emptyFields}
                    item={item}
                    t={t}
                />
                <div className='col-12 mb-4 mt-4'>
                    <DividerWithText title={t('active_schedule')} />
                </div>

                <ActiveScheduleStep
                    item={item}
                    t={t}
                    handleChange={handleChange}
                    emptyFields={emptyFields}
                    dayArray={dayArray}
                    setDayArray={setDayArray}
                    setItem={setItem}
                    disabled={disabled}
                    isCloseTimeInvalid={isCloseTimeInvalid}
                    formatValue={false}

                />
                <div className='col-12 mb-4'>
                    <DividerWithText title={t('geofence_area')} />
                </div>
                <div className={'col-12 mb-4'}>
                    <DefineAreaStep
                        t={t}
                        geofences={geofences}
                        setGeofences={setGeofences}
                        latitude={latitude}
                        setLatitude={setLatitude}
                        longitude={longitude}
                        setLongitude={setLongitude}
                        emptyFields={emptyFields}
                        item={item}
                        setItem={setItem}
                        center={center}
                        disabled={disabled}
                    />
                </div>
            </DivContainerBody>
        </>
    );
};

export default GeofencesUpdate;
